import { render } from "./Pedidos.vue?vue&type=template&id=72e85cf8&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"

import "./Pedidos.vue?vue&type=style&index=0&id=72e85cf8&lang=scss"
import "./Pedidos.vue?vue&type=style&index=1&id=72e85cf8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e85cf8"]])

export default __exports__